var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRastrackLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    zoomAndPan: "magnify",
    viewBox: "0 0 183.75 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "1c6f03d856"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "74d5d0cc00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.582031 13.882812 L 14.605469 13.882812 L 14.605469 31.234375 L 1.582031 31.234375 Z M 1.582031 13.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e918096fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.582031 13.882812 L 8.339844 13.882812 L 14.605469 22.546875 L 8.339844 31.210938 L 1.582031 31.210938 L 7.847656 22.546875 Z M 1.582031 13.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ca6d691cdb"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1c6f03d856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.375,
    width: 220.5,
    fill: "#000000",
    y: -5.25,
    height: 62.999998,
    fillOpacity: 0.58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "21384b6329"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.429688 0.882812 L 13.457031 0.882812 L 13.457031 18.234375 L 0.429688 18.234375 Z M 0.429688 0.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bff33c208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.429688 0.882812 L 7.191406 0.882812 L 13.457031 9.546875 L 7.191406 18.210938 L 0.429688 18.210938 L 6.699219 9.546875 Z M 0.429688 0.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c0492d7861"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 14,
    y: 0,
    height: 19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "85a99363e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.921875 13.882812 L 35.949219 13.882812 L 35.949219 31.234375 L 22.921875 31.234375 Z M 22.921875 13.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c943592cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.921875 13.882812 L 29.683594 13.882812 L 35.949219 22.546875 L 29.683594 31.210938 L 22.921875 31.210938 L 29.1875 22.546875 Z M 22.921875 13.882812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbe1d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.711588, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.734375 -23.140625 C 17.203125 -23.140625 19.09375 -22.660156 20.40625 -21.703125 C 21.726562 -20.742188 22.390625 -19.335938 22.390625 -17.484375 C 22.390625 -15.460938 21.851562 -13.753906 20.78125 -12.359375 C 19.71875 -10.960938 18.257812 -10.101562 16.40625 -9.78125 L 20.921875 0 L 14.8125 0 L 11.28125 -9.25 L 8.765625 -9.25 L 7.453125 0 L 2.359375 0 L 5.625 -23.140625 Z M 9.34375 -13.5625 L 12.546875 -13.5625 C 14.078125 -13.5625 15.207031 -13.789062 15.9375 -14.25 C 16.664062 -14.707031 17.03125 -15.492188 17.03125 -16.609375 C 17.03125 -18.085938 15.882812 -18.828125 13.59375 -18.828125 L 10.09375 -18.828125 Z M 9.34375 -13.5625 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbe1d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.886352, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.453125 -23.140625 L 24.25 0 L 18.5 0 L 17.1875 -4.90625 L 8.203125 -4.90625 L 5.59375 0 L -0.03125 0 L 13.234375 -23.140625 Z M 10.421875 -9.21875 L 16.078125 -9.21875 L 14.25 -16.40625 Z M 10.421875 -9.21875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbe1d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.100083, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.53125 -23.734375 C 16.425781 -23.734375 18.679688 -22.925781 20.296875 -21.3125 L 16.25 -17.515625 C 15.96875 -17.953125 15.5 -18.3125 14.84375 -18.59375 C 14.1875 -18.882812 13.5 -19.03125 12.78125 -19.03125 C 11.6875 -19.03125 10.78125 -18.769531 10.0625 -18.25 C 9.34375 -17.738281 8.984375 -17.09375 8.984375 -16.3125 C 8.984375 -15.75 9.242188 -15.265625 9.765625 -14.859375 C 10.296875 -14.453125 11.398438 -14.007812 13.078125 -13.53125 C 14.554688 -13.070312 15.628906 -12.613281 16.296875 -12.15625 C 16.960938 -11.695312 17.476562 -11.144531 17.84375 -10.5 C 18.21875 -9.863281 18.40625 -9.078125 18.40625 -8.140625 C 18.40625 -5.546875 17.429688 -3.441406 15.484375 -1.828125 C 13.546875 -0.210938 11.148438 0.59375 8.296875 0.59375 C 5.222656 0.59375 2.773438 -0.378906 0.953125 -2.328125 L 5.125 -6.3125 C 5.5625 -5.613281 6.15625 -5.070312 6.90625 -4.6875 C 7.664062 -4.3125 8.457031 -4.125 9.28125 -4.125 C 10.332031 -4.125 11.242188 -4.378906 12.015625 -4.890625 C 12.785156 -5.398438 13.171875 -6.054688 13.171875 -6.859375 C 13.171875 -7.910156 12.203125 -8.757812 10.265625 -9.40625 C 7.890625 -10.195312 6.363281 -10.820312 5.6875 -11.28125 C 5.007812 -11.738281 4.488281 -12.28125 4.125 -12.90625 C 3.769531 -13.539062 3.59375 -14.304688 3.59375 -15.203125 C 3.59375 -17.640625 4.554688 -19.671875 6.484375 -21.296875 C 8.410156 -22.921875 10.757812 -23.734375 13.53125 -23.734375 Z M 13.53125 -23.734375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.858473, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.390625 -20.234375 L 9.734375 -15.6875 L 14.0625 -15.6875 L 13.59375 -12.359375 L 9.28125 -12.359375 L 8.328125 -5.484375 C 8.304688 -5.273438 8.285156 -5.003906 8.265625 -4.671875 C 8.265625 -3.515625 8.910156 -2.9375 10.203125 -2.9375 C 11.117188 -2.9375 11.835938 -3.101562 12.359375 -3.4375 L 11.890625 -0.125 C 11.066406 0.21875 10 0.390625 8.6875 0.390625 C 7.125 0.390625 5.984375 0.109375 5.265625 -0.453125 C 4.546875 -1.023438 4.1875 -1.984375 4.1875 -3.328125 C 4.226562 -4.023438 4.28125 -4.640625 4.34375 -5.171875 L 5.359375 -12.359375 L 2.125 -12.359375 L 2.578125 -15.6875 L 5.8125 -15.6875 L 6.46875 -20.234375 Z M 10.390625 -20.234375 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.569866, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.078125 -16.078125 C 13.441406 -16.078125 13.910156 -16.003906 14.484375 -15.859375 L 13.953125 -12.0625 C 13.234375 -12.257812 12.613281 -12.359375 12.09375 -12.359375 C 10.8125 -12.359375 9.742188 -11.972656 8.890625 -11.203125 C 8.035156 -10.441406 7.515625 -9.507812 7.328125 -8.40625 L 6.140625 0 L 2.21875 0 L 4.40625 -15.6875 L 8.328125 -15.6875 L 8.015625 -13.203125 L 8.078125 -13.203125 C 8.640625 -14.117188 9.351562 -14.828125 10.21875 -15.328125 C 11.09375 -15.828125 12.046875 -16.078125 13.078125 -16.078125 Z M 13.078125 -16.078125 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.28126, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.109375 -16.078125 C 15.035156 -16.078125 17 -14.410156 17 -11.078125 C 17 -10.773438 16.96875 -10.207031 16.90625 -9.375 L 15.5625 0 L 12.03125 0 L 12.328125 -2.15625 L 12.21875 -2.15625 C 10.9375 -0.5 9.140625 0.347656 6.828125 0.390625 C 5.367188 0.390625 4.160156 0.0234375 3.203125 -0.703125 C 2.242188 -1.429688 1.753906 -2.394531 1.734375 -3.59375 C 1.753906 -5.570312 2.59375 -7.097656 4.25 -8.171875 C 5.90625 -9.242188 8.628906 -9.78125 12.421875 -9.78125 L 13.40625 -9.78125 C 13.46875 -10.101562 13.5 -10.40625 13.5 -10.6875 C 13.5 -11.425781 13.222656 -12.019531 12.671875 -12.46875 C 12.128906 -12.914062 11.335938 -13.140625 10.296875 -13.140625 C 8.660156 -13.140625 7.175781 -12.59375 5.84375 -11.5 L 4.078125 -13.5625 C 6.003906 -15.21875 8.347656 -16.054688 11.109375 -16.078125 Z M 5.71875 -4.3125 C 5.71875 -3.832031 5.941406 -3.414062 6.390625 -3.0625 C 6.835938 -2.71875 7.441406 -2.546875 8.203125 -2.546875 C 9.492188 -2.546875 10.519531 -2.851562 11.28125 -3.46875 C 12.039062 -4.09375 12.5 -4.972656 12.65625 -6.109375 L 12.78125 -7.03125 L 11.765625 -7.03125 C 7.734375 -7.03125 5.71875 -6.125 5.71875 -4.3125 Z M 5.71875 -4.3125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.82886, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.21875 -16.078125 C 14.550781 -16.078125 16.335938 -15.285156 17.578125 -13.703125 L 14.484375 -10.984375 C 13.585938 -12.023438 12.660156 -12.546875 11.703125 -12.546875 C 10.265625 -12.546875 9.023438 -12.007812 7.984375 -10.9375 C 6.953125 -9.875 6.425781 -8.582031 6.40625 -7.0625 C 6.40625 -5.945312 6.765625 -5.019531 7.484375 -4.28125 C 8.203125 -3.539062 9.171875 -3.160156 10.390625 -3.140625 C 11.679688 -3.140625 12.769531 -3.628906 13.65625 -4.609375 L 15.890625 -1.796875 C 15.054688 -1.117188 14.101562 -0.582031 13.03125 -0.1875 C 11.96875 0.195312 10.925781 0.390625 9.90625 0.390625 C 7.675781 0.390625 5.875 -0.257812 4.5 -1.5625 C 3.132812 -2.875 2.453125 -4.53125 2.453125 -6.53125 C 2.453125 -9.21875 3.410156 -11.472656 5.328125 -13.296875 C 7.242188 -15.128906 9.539062 -16.054688 12.21875 -16.078125 Z M 12.21875 -16.078125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.57922, 33.618694)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.609375 -24.71875 L 7.421875 -9.1875 L 14.375 -15.6875 L 19.421875 -15.6875 L 11.703125 -8.5625 L 17.65625 0 L 12.453125 0 L 7.328125 -8.015625 L 7.25 -8.015625 L 6.140625 0 L 2.21875 0 L 5.6875 -24.71875 Z M 9.609375 -24.71875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74d5d0cc00)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e918096fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M 1.582031 13.882812 L 14.605469 13.882812 L 14.605469 31.234375 L 1.582031 31.234375 Z M 1.582031 13.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca6d691cdb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12, 13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0492d7861)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#21384b6329)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bff33c208)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M 0.429688 0.882812 L 13.457031 0.882812 L 13.457031 18.234375 L 0.429688 18.234375 Z M 0.429688 0.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85a99363e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c943592cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.921875 13.882812 L 35.949219 13.882812 L 35.949219 31.234375 L 22.921875 31.234375 Z M 22.921875 13.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRastrackLogoDark);
export default __webpack_public_path__ + "static/media/rastrack-logo-dark.5a5e3dd73e841db0f95713811eb2e265.svg";
export { ForwardRef as ReactComponent };